export class Item {
  public id: string
  public title: string
  constructor(id: string, title: string) {
    this.id = id
    this.title = title
  }
}

export interface PItem {
  id: number;
  name: string;
}

export default Item
